export const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
] as const

export type DayOfWeek = (typeof daysOfWeek)[number]

const stringDaysOfWeek: string[] = [...daysOfWeek]
export const isDayOfWeek = (string: string): string is DayOfWeek =>
  stringDaysOfWeek.includes(string)
